var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-spacer'),_c('v-btn',{on:{"click":_vm.signout}},[_vm._v("Odjavi se ("+_vm._s(_vm.name)+")")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }